<script>
import CompanyServicesItem from "@js/components/Sections/Services/Components/CompanyServicesItem.vue";
import sell_img from "@img/services/sell.webp"
import delivery_img from "@img/services/delivery.webp";
import monatzh_img from "@img/services/montazh.webp";
import demontazh_img from "@img/services/demontazh.webp";

export default {
    name: "CompanyServices",
    components: {CompanyServicesItem},
    setup() {
        return {
            sell_img, delivery_img, monatzh_img, demontazh_img
        }
    }
}
</script>

<template>
    <div class="pt-20">
        <CompanyServicesItem :title="'Поставка и продажа дорожных плит'"
                             :img="sell_img"
                             :btnText="'Заказать поставку'">
            <p class="mb-2 text-gray-600 text-sm">
                Мы предлагаем широкий ассортимент железобетонных дорожных плит, предназначенных для обустройства
                временных и
                постоянных дорог, подъездных путей, строительных площадок и промышленных объектов. В наличии имеются
                плиты
                различных типоразмеров, соответствующих стандартам ГОСТ, что гарантирует их высокую прочность и
                долговечность.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Наши специалисты помогут вам подобрать оптимальные плиты с учетом нагрузки, условий эксплуатации и
                бюджета.
                Мы работаем как с частными клиентами, так и с крупными застройщиками, предлагая конкурентные цены и
                гибкие
                условия сотрудничества. Вся продукция проходит строгий контроль качества, включая тестирование на
                прочность
                и устойчивость к внешним воздействиям.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Мы предоставляем официальные документы на каждую партию плит, включая сертификаты соответствия и
                паспорта
                качества. Покупая дорожные плиты у нас, вы получаете продукцию, отвечающую всем требованиям безопасности
                и
                долговечности.
            </p>
        </CompanyServicesItem>
        <CompanyServicesItem :title="'Доставка и выгрузка на объект'"
                             :img="delivery_img"
                             :rtl="true"
                             :btnText="'Заказать доставку'"
                             class="mt-10 md:mt-20">
            <p class="mb-2 text-gray-600 text-sm">
                Доставка и разгрузка дорожных плит – важный этап в строительстве, требующий профессионального подхода.
                Мы
                располагаем собственным автопарком спецтехники, что позволяет нам оперативно осуществлять поставки в
                любые
                точки Москвы и Московской области. В нашем распоряжении: манипуляторы, краны, бортовые машины
                грузоподъемностью от 5 до 40 тонн, что обеспечивает безопасность и точность при транспортировке.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Наша логистическая служба работает без выходных, что позволяет нам выполнять заказы точно в срок. Мы
                учитываем особенности вашего объекта и предлагаем удобные условия доставки, включая гибкий график и
                согласование времени разгрузки.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Процесс доставки организован таким образом, чтобы минимизировать риски повреждения плит. Перед отправкой
                каждая партия проверяется на целостность, а во время транспортировки используются защитные материалы,
                предотвращающие механические повреждения. По прибытии на объект наши специалисты могут проконтролировать
                процесс выгрузки, обеспечивая безопасность и точность размещения плит.
            </p>
        </CompanyServicesItem>
        <CompanyServicesItem :title="'Монтаж и укладка плит'"
                             :img="monatzh_img"
                             :btnText="'Заказать монтаж'"
                             class="mt-10 md:mt-20">
            <p class="mb-2 text-gray-600 text-sm">
                Профессиональный монтаж дорожных плит – залог их долговечности и
                надежности. Мы предлагаем комплексные услуги по укладке железобетонных плит с соблюдением всех
                строительных норм и технологий. Наши специалисты имеют многолетний опыт работы с различными типами
                оснований, что позволяет нам гарантировать высокое качество выполнения работ.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Процесс укладки включает подготовку основания, точное позиционирование
                плит, выравнивание и фиксацию. В зависимости от условий эксплуатации мы можем предложить различные
                способы монтажа, включая армирование и усиление плит дополнительными конструкциями.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Работы выполняются с применением специализированной техники, что
                обеспечивает максимальную точность и скорость. Наши клиенты могут быть уверены в том, что дорожное
                покрытие будет устойчивым к нагрузкам, температурным перепадам и механическим воздействиям.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Дополнительно мы предоставляем услуги по техническому обслуживанию
                уложенных плит, включая их укрепление, устранение дефектов и защитное покрытие для увеличения срока
                службы.
            </p>
        </CompanyServicesItem>
        <CompanyServicesItem :title="'Демонтаж и утилизация'"
                             :img="demontazh_img"
                             :rtl="true"
                             :btnText="'Заказать демонтаж'"
                             class="mt-10 md:mt-20">
            <p class="mb-2 text-gray-600 text-sm">
                Мы предлагаем профессиональные услуги по демонтажу и утилизации старых дорожных плит, обеспечивая
                комплексный подход к реконструкции и обновлению покрытий. Наши специалисты выполняют демонтаж с учетом
                всех технических и экологических норм, минимизируя негативное воздействие на окружающую среду.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Демонтажные работы включают разборку плит, погрузку на спецтехнику и вывоз с объекта. При необходимости
                мы проводим разделение материалов для их дальнейшей переработки, что позволяет снизить затраты на
                утилизацию и уменьшить объем строительных отходов.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Старые плиты могут быть переработаны и использованы в повторном строительстве, что делает наш подход
                экологичным и экономически выгодным для заказчиков. Мы предлагаем гибкие условия сотрудничества и
                подстраиваемся под график работ заказчика, чтобы минимизировать простои и оптимизировать строительные
                процессы.
            </p>
            <p class="mb-2 text-gray-600 text-sm">
                Сотрудничая с нами, вы получаете полный спектр услуг – от поставки и монтажа до демонтажа и утилизации
                дорожных плит. Обращайтесь к нам, и мы подберем лучшее решение для вашего объекта!
            </p>
        </CompanyServicesItem>
    </div>
</template>

<style scoped lang="scss">

</style>
